<template>
  <!-- 修改邮箱弹窗 -->
  <custom-dialog :title="model.title" width="600px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item :label="$t('Common.com_email')" prop="email">
          <el-input v-model="form.email" :placeholder="$t('change_email_dialog.qsryx')" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        email: '',
      },
      userInfo: {},
    };
  },
  computed: {
    rules() {
      return {
        email: [{ required: true, message: this.$t('change_email_dialog.you_xiang_bi_tian') }],
      };
    }
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.userInfo = this.model.row;
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.row || {});
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.UserEmail, { email: this.form.email }, true)
          .then(() => {
            this.visible = false;
            this.userInfo.email = this.form.email;
            this.$store.commit('USERINFO', this.userInfo);
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="scss"></style>
